export default "__VITE_ASSET__DGaIYugX__"